export const swiperProductSettings = {
  spaceBetween: 16,
  breakpoints: {
    0: {
      slidesPerView: 1.5,
      loop: true,
      pagination: {
        el: '.ourProducts .swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 2.9,
      loop: true,
      pagination: {
        el: '.ourProducts .swiper-pagination',
        clickable: true,
      },
    },
  },
};
export const swiperAwardsSetting = {
  breakpoints: {
    0: {
      centeredSlides: false,
      initialSlide: 0,
      loop: true,
      spaceBetween:16,
      slidesPerView: 1.35,
      pagination: {
        el: '.awardsSwiper  .swiper-pagination',
        clickable: true,
      },
    },
    768: {
      centeredSlides: false,
      loop: true,
      slidesPerView: 2.9,
      spaceBetween:24,
      pagination: {
        el: '.awardsSwiper .swiper-pagination',
        clickable: true,
      },
    },
    1024: {
      initialSlide: 1,
      centeredSlides: true,
      loop: true,
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};
export const partnersSwiperSetting = {
  slidesPerView: 9,
  slidesPerGroup: 1,
  loop: true,
  spaceBetween: 24,
  freeMode: false,
  speed: 4000,  // Adjusted speed for continuous transition
  autoplay: {
    delay: 0,  // Continuous autoplay with no delay
    disableOnInteraction: false,
    waitForTransition: true,
  },
  allowTouchMove: true,  // Allow manual touch/mouse dragging
  breakpoints: {
    0: {  // Small devices (portrait phones, less than 768px)
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 7,
      spaceBetween: 12,
    },
    1560: {  // Large devices (tablets, 768px and up)
      slidesPerView: 9,
      spaceBetween: 24,
    },
  },
};
export const jurisdictionAllSwiperSettings = {
  loop:true,
  breakpoints: {
    0: {
      slidesPerView: 1.4,
      pagination: {
        el: '.jurisdictionsSwiper .swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 1.3,
      loop: true,
      pagination: {
        el: '.jurisdictionsSwiper .swiper-pagination',
        clickable: true,
      },
    },
    1024: {
      slidesPerView: 2.5,
      loop: true,
      pagination: {
        el: '.jurisdictionsSwiper .swiper-pagination',
        clickable: true,
      },
    },
  },
}
export const jurisdictionGamesSwiperSettings = {
  breakpoints: {
    0: {
      slidesPerView: 1.4,
      loop:true,
      pagination: {
        el: '.jurisdictionsGameSwiper .swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 1.3,
      loop: true,
      pagination: {
        el: '.jurisdictionsGameSwiper .swiper-pagination',
        clickable: true,
      },
    },
    1024: {
      slidesPerView: 2.5,
      loop: true,
      pagination: {
        el: '.jurisdictionsGameSwiper .swiper-pagination',
        clickable: true,
      },
    },
  },
}
export const newsSwiperSettings = {
  breakpoints: {
    0: {
      slidesPerView: 1.35,
      spaceBetween:16,
      loop: true,
      pagination: {
        el: '.newsSwiper .swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 2.9,
      loop: true,
      spaceBetween:24,
      pagination: {
        el: '.newsSwiper .swiper-pagination',
        clickable: true,
      },
    },
  },
}

export const relatedNewsSettings = {
  slidesPerView: 1.4,
  spaceBetween: 16,
  loop: true,
  pagination: {
    el: ' .swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.4,
    },
    700: {
      slidesPerView: 2.7,
    },
  },
}

export const cabinetsSwiperSettings = {
  slidesPerView: 1.09,
  spaceBetween: 24,
  loop: false,
  pagination: {
    el: ' .swiper-pagination',
    clickable: true,
  },
}

export const ongsCharacteristicsSettings = {
  slidesPerView: 1.1,
  spaceBetween: 16,
  loop: true,
  pagination: {
    el: ' .swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    768: {
      slidesPerView: 2.2,
    },
  },
}

export const finctionalitiesSettings = {
  slidesPerView: 1,
  spaceBetween: 16,
  effect: 'fade',
  pagination: {
    el: ' .swiper-pagination',
    clickable: true,
  },
}

export const relatedGamesSettings = {
  slidesPerView: 1,
  spaceBetween: 24,
  pagination: {
    el: '.games-swiper .swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 24,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
  },
}




// WEBPACK FOOTER //
// ./scripts/exports/swiperSettings.js